import React, { useEffect, useState } from "react";
import {
  createshipment,
  getPendingShipmentCreation,
} from "../../../services/apiService";


const Shipment = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchProducts(page, pageSize);
  }, [page, pageSize]);

  const fetchProducts = async (page, pageSize) => {
    setLoading(true);
    try {
      const data = await getPendingShipmentCreation();
      setProducts(data.data);
      console.log(data.data)
      //  setTotalItems(data.length);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (index, field, value) => {
    const updated = [...products];
    updated[index][field] = value;
    setProducts(updated);
  };

  const handleSubmit = async (product) => {
    try {
      const ship = product.ship || {};
      await createshipment(
        {
          shipments: [{
            name: ship.name || "",
            add: `${ship.flathouse || ""},${ship.area || ""},${ship.landmark || ""}`,
            pin: ship.pincode || "",
            city: ship.city || "",
            state: ship.state || "",
            country: ship.country || "",
            phone: ship.phone || "",
            order: product.orderid,
            payment_mode: "Prepaid",
            quantity: 1,
            waybill: ship.waybill || "",
            shipment_width: product.width || 0,
            shipment_height: product.height || 0,
            weight: product.weight?.[0]?.grossw || 0,
            shipping_mode: "Surface",
            address_type: ship.type || "",
          }],
          pickup_location:  {
      "name": "PIXEL",
      "add": "Plot No.F4,FICCI FLO, Industrial Park Sultanpur, Sultanpur Village,Telangana",
      "city": "HYDERABAD",
      "pin_code": "502319",
      "country": "India",
      "phone": "9948123450"
    },

        }
      );
      alert("Stock updated successfully!");
      fetchProducts(page, pageSize);
    } catch (err) {
      console.error(err);
      alert("Failed to update stock");
    }
  };

  //  const handleAddRack = async (product, index) => {
  //    if (!product.rackPosition) {
  //      alert("Please enter a rack position before adding!");
  //      return;
  //    }

  //    try {
  //      await addRack(product.productid, product.rackPosition);
  //      alert("Rack added successfully!");
  //      fetchProducts(page, pageSize);

  //      const updated = [...products];
  //      updated[index].disabled = true;
  //      setProducts(updated);
  //    } catch (err) {
  //      console.error(err);
  //      alert("Failed to add rack");
  //    }
  //  };

  //  const handleRemove = async (product, index) => {
  //    if (!product.rackPosition) {
  //      alert("Please enter a rack position to remove!");
  //      return;
  //    }

  //    try {
  //      await removeRack(product.productid, product.rackPosition);
  //      alert("Rack removed successfully!");
  //      fetchProducts(page, pageSize);
  //    } catch (err) {
  //      console.error(err);
  //      alert("Failed to remove rack");
  //    }
  //  };

  const totalPages = Math.ceil(totalItems / pageSize);

  // Filter products based on search text
  // Filter products based on search text (productid, subcategory, modelno)
  const filteredProducts = products?.filter((p) => {
    const search = searchText.trim().toLowerCase();
    if (!search) return true; // show all if search is empty
    return (
      p.productid.toString().includes(search) ||
      (p.subcategory && p.subcategory.toLowerCase().includes(search)) ||
      (p.modelno && p.modelno.toLowerCase().includes(search))
    );
  });

  if (loading) return <p>Loading...</p>;

  return (
    <div className="stock-tools-container">
      <input
        type="text"
        placeholder="Search ID, SubCategory, or Model No"
        className="search-input"
        value={searchText}
      // onChange={(e) => setSearchText(e.target.value)}
      />


      <table className="stock-table">
        <thead>
          <tr>
            <th>OrderId</th>
            <th>Orderdate</th>
            <th>Width</th>
            <th>Height</th>
            <th>CartoonsCount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredProducts.map((p, i) => (
            <tr key={p.orderid}>
              <td>{p.orderid}</td>
              <td style={{ padding: "6px 8px" }}>  {new Date(p.orderdate)
                .toLocaleDateString("en-GB")
                .replace(/\//g, "-")}</td>
              <td>
                <input
                  type="text"
                  placeholder="Enter Width"
                  value={p.width || ""}
                  onChange={(e) =>
                    handleChange(i, "width", e.target.value)
                  }
                  className="rack-input"
                />
              </td>
              <td>
                <input
                  type="number"
                  placeholder="Enter Height"
                  value={p.height || ""}
                  onChange={(e) => handleChange(i, "height", e.target.value)}
                  className="qty-input"
                />
              </td>
              <td>
                <input
                  type="number"
                  placeholder="Enter Cartoons Count"
                  value={p.cartons || ""}
                  onChange={(e) => handleChange(i, "cartons", e.target.value)}
                  className="qty-input"
                />
              </td>
              <td className="action-buttons">
                <button
                  className="submit-btn"
                  onClick={() => handleSubmit(p)}
                // disabled={!p.width || !p.height || p.cartons}
                >
                  Create
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}

      <div className="pagination-container">


        <div>

          Items per page:

          <select
            className="page-select"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setPage(1);
            }}
          >

            {[5, 10, 20, 50].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}

          </select>

        </div>



        <div className="page-buttons">

          <button
            className="page-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Previous
          </button>


          <span className="page-count">

            {page} / {totalPages || 1}

          </span>


          <button
            className="page-btn"
            disabled={page === totalPages || totalPages === 0}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>

        </div>


      </div>

      {/* Styles */}
      <style>{`
          .stock-tools-container {
            padding: 20px;
            font-family: Arial, sans-serif;
          }

          .search-input {
            margin-bottom: 15px;
            padding: 6px 10px;
            width: 200px;
            border: 1px solid #ccc;
            border-radius: 4px;
          }

          .stock-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 15px;
          }

          .stock-table th,
          .stock-table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: center;
          }

          .stock-table th {
            background-color: #f5f5f5;
          }

          .rack-input,
          .qty-input {
            width: 90%;
            padding: 4px 6px;
            border: 1px solid #ccc;
            border-radius: 4px;
          }

          .action-buttons {
            display: flex;
            justify-content: center;
            gap: 5px;
            flex-wrap: nowrap;
          }

          .action-buttons button {
            padding: 5px 10px;
            border: none;
            border-radius: 4px;
            color: #fff;
            cursor: pointer;
            font-size: 12px;
          }

          .submit-btn { background-color: #4CAF50; } /* green */
          .add-rack-btn { background-color: #2196F3; } /* blue */
          .remove-btn { background-color: #f44336; } /* red */

          .pagination {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
            font-size: 14px;
          }

          .pagination select {
            margin-left: 5px;
            padding: 3px 6px;
          }

          .page-controls button {
            padding: 4px 8px;
            margin: 0 3px;
            border: 1px solid #ccc;
            border-radius: 4px;
            cursor: pointer;
          }

          .page-controls button:disabled {
            cursor: not-allowed;
            opacity: 0.5;
          }
        `}</style>
    </div>
  );
};

export default Shipment;
